module.exports = __webpack_public_path__ + "static/img/img_t.856788fb.webp";